import { useState } from "react";
import FormInput from "../../components/FormInput";
import { Form } from "react-router-dom";
import IconCheck from "../../icons/IconCheck";
import Spacer from "../../components/Spacer";
import Button from "../../components/Button";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import Message from "../../components/Message";

export default function ProfileEdit({ profileInfo, onProfileEditted }) {
  const [loading, setLoading] = useState(false);
  const [profileInfoToUpdate, setProfileInfoToUpdate] = useState(profileInfo);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Update profile info
  const update = async () => {
    setLoading(true);
    var url =
      profileInfoToUpdate.user_type === "user"
        ? apiUrl + "users/" + profileInfoToUpdate.uuid
        : apiUrl + "customers/" + profileInfoToUpdate.uuid;
    await executeRequest(
      url,
      "POST",
      profileInfoToUpdate,
      {
        Authorization: "Bearer " + getToken(),
        "Content-type": "application/json",
      },
      (data) => {
        console.log(data);
        onProfileEditted();
        setMessage("Profile successfully updated.");
        setMessageType("success");
      },
      (error) => {
        setMessage("Error updating profile.");
        setMessageType("danger");
      }
    );
    setLoading(false);
  };

  return (
    <>
      <h1 className="page-title">Edit Profile</h1>
      <FormInput
        title="First name"
        type="text"
        value={profileInfoToUpdate.first_name}
        onChanged={(value) =>
          loading
            ? null
            : setProfileInfoToUpdate((prev) => ({
                ...prev,
                first_name: value,
              }))
        }
      />
      <Spacer />
      <FormInput
        title="Last name"
        type="text"
        value={profileInfoToUpdate.last_name}
        onChanged={(value) =>
          loading
            ? null
            : setProfileInfoToUpdate((prev) => ({
                ...prev,
                last_name: value,
              }))
        }
      />
      <Spacer />
      <FormInput
        title="Email"
        type="text"
        value={profileInfoToUpdate.email}
        onChanged={(value) =>
          loading
            ? null
            : setProfileInfoToUpdate((prev) => ({
                ...prev,
                email: value,
              }))
        }
      />
      <Spacer />
      <FormInput
        title="Phone"
        type="text"
        value={profileInfoToUpdate.phone}
        onChanged={(value) =>
          loading
            ? null
            : setProfileInfoToUpdate((prev) => ({
                ...prev,
                phone: value,
              }))
        }
      />
      <Spacer />
      <Button
        text="Update"
        icon={<IconCheck />}
        onClicked={() => update()}
        disabled={loading}
        loading={loading}
      />
      {message.length > 0 && messageType.length > 0 && (
        <Message message={message} type={messageType} />
      )}
    </>
  );
}
